import { useCallback, useMemo } from 'react';

import {
  createSpec,
  specTypes,
  useFetch,
  useDataRefId,
  useRefetch,
} from '@bingads-webui-react/overreact';

import {
  fetchRequestContract,
  fetchResponseContract,
} from '../spec/fetch';
import { environmentLookupFn } from '../../../environment/environment-instance';
import type {
  FetchAndRefetchConfig,
  ReadParameters,
  ReadRequestConfig,
  SignUpPayload,
  SignUpResult,
  SignUpVariables,
} from '../../../types';

const fetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.FETCH, null, environmentLookupFn
);
const refetchSpec = createSpec(
  fetchRequestContract, fetchResponseContract,
  specTypes.REFETCH, null, environmentLookupFn
);


export function useSignUp(
  dataLocator: SignUpVariables,
  config: FetchAndRefetchConfig<SignUpResult, SignUpVariables> = {}
) {
  const dataRefId = useDataRefId(null, environmentLookupFn);
  const defaultConfig = useMemo(() => ({

    fetch: config.fetch || {},

    refetch: config.refetch || {},
  }), [config]);
  const { fetch: fetchConfig, refetch: refetchConfig } = defaultConfig;
  const [data, error] = useFetch(dataRefId, fetchSpec, dataLocator, fetchConfig) as [
    SignUpResult | undefined,
    unknown,
  ];

  const refetchFn = useRefetch(dataRefId, refetchSpec, refetchConfig);

  const read = useCallback((
    param: ReadParameters<SignUpVariables, SignUpPayload> = {},
    requestConfig?: ReadRequestConfig<SignUpResult, SignUpVariables>
  ) => {
    refetchFn({
      variables: { ...dataLocator, ...param.variables },
      payload: { ...param.data },
    }, requestConfig);
  }, [dataLocator, refetchFn]);

  return [{ data, error }, { read }];
}
